import preloadedTopVehicles from '../../data-preloaded/top-vehicles-data';
import { ModeloVehiculo } from '../../types/vehicle.types';

export function getModelsByBrand(brand: string): ModeloVehiculo[] {
  const data = preloadedTopVehicles as ModeloVehiculo[];
  return data.filter(
    (vehicle: ModeloVehiculo) =>
      vehicle.marca?.toUpperCase() === brand?.toUpperCase()
  );
}
